import { handleJSON } from '@/utils/fetch-utils';

const { API_URL } = process.env;
export const headers = () => {
  return {
    'Content-Type': 'application/json',
    authorization: `Bearer ${localStorage.token}`,
  };
};

export const uploadFileHeaders = () => {
  return {
    authorization: `Bearer ${localStorage.token}`,
  };
};

// noinspection JSUnusedGlobalSymbols
export default {
  endpoints: {
    organizations: `${API_URL}/organizations/`,
    organizationLevels: organizationId => `${API_URL}/organizations/${organizationId}/levels/`,
    countries: `${API_URL}/countries/`,
    languages: `${API_URL}/languages/`,
    timeZones: `${API_URL}/time-zones/`,
    learnersLevels: `${API_URL}/learners-levels/`,
    featureGroups: organizationId => `${API_URL}/organizations/${organizationId}/groups/`,
    availableGroupsByOrg: organizationId => `${API_URL}/manage-learners-available-groups/${organizationId}/`,
    availableFeatureGroups: `${API_URL}/assignments/available-groups/`,
    permissions: `${API_URL}/organizations/permissions/`,
    groupPermissions: `${API_URL}/groups/permissions/`,
    pipeline: `${API_URL}/pipeline-metadata/`,
    courseLanguages: `${API_URL}/course-languages/`,
    organizationCustomerPackages: organizationId => `${API_URL}/organizations/${organizationId}/packages/`,
  },

  fetchCountries() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.countries;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchFeatureGroups(organizationId) {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.featureGroups(organizationId);

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchAvailableGroupsByOrg(organizationId) {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.availableGroupsByOrg(organizationId);

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchAvailableFeatureGroups() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.availableFeatureGroups;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchPermissions() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.permissions;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchGroupPermissions() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.groupPermissions;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchLanguages() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.languages;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchCourseLanguages() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.courseLanguages;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchTimeZones() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.timeZones;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchOrganizations() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.organizations;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchOrganizationLevels(organizationId) {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.organizationLevels(organizationId);

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchLastUpdatedAt() {
    const options = {
      method: 'GET',
      headers: headers(),
    };

    const endpoint = this.endpoints.pipeline;

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchOrganizationCustomerPackages(organizationId) {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.organizationCustomerPackages(organizationId);

    return fetch(endpoint, options).then(handleJSON);
  },
};
